// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import ApiService from "src/services/ApiService";
import useDebounce from "src/hooks/use-debounce";

export default function AutocompleteTextField({
  label,
  setValue,
  defaultValue,
  endpoint,
  labelField = "label",
  className = "",
  disabled,
  multiple = false,
}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [searchTerm, setSearchTerm] = useState("");
  const [defaultV, setDefaultV] = useState(
    defaultValue ? (multiple ? [...defaultValue] : { ...defaultValue }) : (multiple ? [] : null)
  );
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const getOptions = async () => {
    let queryString = "";
    if (searchTerm) {
      queryString += `_q=${searchTerm}`;
    }

    if (endpoint == "categories") {
      queryString += `status=true`;
      queryString += `&channel=1`;
    }
    const values = await ApiService.get(`/${endpoint}?${queryString}`);
    if (open) {
      setOptions(values);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getOptions();
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      let queryString = "";
      if (endpoint == "categories") {
        queryString += `status=true`;
        queryString += `&channel=1`;
      }
      const values = await ApiService.get(`/${endpoint}?${queryString}`);
      if (active) {
        setOptions(values);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      className={className}
      id={`asynchronous-demo-${Math.random()}`}
      style={{ width: "100%" }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) =>
        option[labelField] === value[labelField]
      }
      getOptionLabel={(option) => option[labelField]}
      options={options}
      defaultValue={defaultV}
      loading={loading}
      onChange={(event, value, reason) => setValue(value)}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label || "Nhập từ khoá"}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          onChange={(event) => {
            setSearchTerm(event.target.value);
          }}
        />
      )}
      multiple={multiple}
    />
  );
}
